import React, { useEffect, useState } from "react";

import moment from "moment";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../../store/root_reducer";
import { fetchRequest } from "../../../store/widgets/api_state/actions";
import { IntervalType } from "../../../store/widgets/types";
import { IntervalSelector } from "../components";
import { Widget } from "../widget";

import { ApiStateChart } from "./components";

export interface ApiStateWidgetProps {
  className?: string;
}

export const ApiStateWidget: React.FC<ApiStateWidgetProps> = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation("api_state_widget");

  const [interval, setInterval] = useState<IntervalType>("today");

  const widgetState = useSelector((state: RootState) => state.Widgets.ApiState);
  const selectedGate = useSelector((state: RootState) => state.User.selectedGate);

  useEffect(() => {
    dispatch(fetchRequest({ interval, gateId: selectedGate.id }));
  }, [dispatch, selectedGate, interval]);

  return (
    <Widget
      className={props.className}
      isLoading={widgetState.isLoading}
      lastUpdated={moment.utc(widgetState.lastUpdate)}
      title={
        <div>
          {t("title")} <IntervalSelector value={interval} onSelect={setInterval} />
        </div>
      }
    >
      <ApiStateChart
        zerosPercent={widgetState.percentZerosResponses}
        errorsPercent={widgetState.percentErrorsResponses}
        timeoutsPercent={widgetState.percentTimeouts}
        successfulPercent={widgetState.percentSuccessfulResponses}
      />
    </Widget>
  );
};
